import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import TestimonialSlide from "./TestimonialSlide";

const SectionSix = () => {
	var settings = {
		dots: true,
		infinite: true,
		speed: 900,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
	};
	return (
		<div className="text-center h-screen mobiles:transform mobiles:translate-y-96 mobiles:top-8 relative z-0 testimonials-sd pb-20">
			<div className="pb-20 pt-28 global-container">
				<Slider {...settings}>
					<TestimonialSlide />
					<TestimonialSlide />
					<TestimonialSlide />
				</Slider>
			</div>
		</div>
	);
};

export default SectionSix;
